import React from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-primary" data-testid="privacy-home-link">
          <BookOpen className="h-5 w-5" />
          <span className="font-serif text-lg font-black tracking-tight">DocCircle</span>
        </Link>
        <p className="mt-16 text-xs uppercase tracking-[0.25em] text-primary">Legal</p>
        <h1 className="mt-4 font-serif text-4xl lg:text-5xl font-black tracking-tight">Privacy Policy</h1>
        <p className="mt-6 text-sm text-muted-foreground">
          Last updated: coming soon · Effective on account creation
        </p>

        <div className="mt-12 space-y-8 text-[15px] leading-relaxed text-foreground/90">
          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Privacy first, always</h2>
            <p className="mt-3">
              Doctoral work is intimate. Your dissertation topic, your setbacks, your stage, your chair — none of that
              belongs on a public feed. DocCircle is engineered so that your work stays private by default and every
              share is a conscious choice.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">What we collect</h2>
            <p className="mt-3">
              Account basics (name, email, doctoral program, methodology, current stage), the milestones you record
              on your private journey, and the privacy preferences you set. We do not track you across the web
              and we do not sell data to third parties.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Who can see your profile</h2>
            <p className="mt-3">
              Only what you decide. You control, field by field, whether your university, research topic, working
              title, expected graduation year, and interests are visible to other authenticated members or kept private.
              Your journey milestones are always private to you.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Security</h2>
            <p className="mt-3">
              Passwords are hashed with bcrypt. Session cookies are HttpOnly, Secure, and SameSite=Strict.
              We enforce CSRF protection on state-changing requests and log all sensitive account events for
              your safety.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Your rights</h2>
            <p className="mt-3">
              You can export or delete your data at any time by contacting us. We will honor deletion requests
              within thirty days. The full Privacy Policy, including retention windows and data-processing
              partners, will be published before Phase 2 launches.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Contact</h2>
            <p className="mt-3">
              Privacy questions? Reach us at{" "}
              <a href="mailto:privacy@doccircle.com" className="text-primary underline underline-offset-4">
                privacy@doccircle.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <Link to="/" className="text-sm text-primary underline underline-offset-4" data-testid="privacy-back-link">
            ← Back to DocCircle
          </Link>
        </div>
      </div>
    </div>
  );
}
